<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    maxHeight="700"
    :footerHide="true"
    @on-close="handleMsgBoxClose"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">本次大赛需要组队参加，请问您想</span>
    </p>
    <div class="model-content">
      <div class="team-up">
        <img alt="" src="~@/assets/competition/create-team-2x.png" />
        <comp-button class="btn-icon" @click="handleTeamCreate"
          >创建队伍</comp-button
        >
      </div>
      <div class="team-join">
        <img alt="" src="~@/assets/competition/join-team-2x.png" />
        <comp-button class="btn-icon" type="info" @click="handleTeamJoin"
          >加入队伍</comp-button
        >
      </div>
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'

export default {
  name: 'TeamUp',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CompButton
  },
  data() {
    return {
      showModal: false
    }
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    handleMsgBoxClose() {
      this.$emit('stateChange', '')
    },
    handleTeamCreate() {
      this.$emit('stateChange', 'createTeam')
    },
    handleTeamJoin() {
      this.$emit('stateChange', 'joinTeam')
    }
  },
  watch: {
    value(val) {
      this.showModal = val
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.model-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  > div {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    img {
      height: 88px;
      width: 88px;
    }
    .btn-icon {
      margin-top: 16px;
    }
    &.team-up .btn-icon {
      background-color: #3060ff;
      background-image: linear-gradient(42deg, #3060ff 0%, #5db7ff 100%);
      font-size: 14px;
      color: #ffffff;
    }
    &.team-join {
      margin-left: 96px;
      .btn-icon {
        border: 1px solid #243bfb;
        color: #243bfb;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamUp/TeamUp.vue